import { SVGProps } from "react";

const LikeIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_10413_82611)">
				<path
					d="M31.1395 19.2721C31.1395 18.513 30.8809 17.8137 30.4481 17.2559C31.2993 16.6594 31.8574 15.6719 31.8574 14.5559C31.8574 12.7387 30.379 11.2603 28.5618 11.2603L20.8912 11.2603L21.9659 7.548L21.9659 5.8035C21.9659 2.60344 19.3624 3.36085e-06 16.1624 2.80133e-06C15.4073 2.6693e-06 14.7929 0.614378 14.7929 1.3695L14.7929 5.26694C14.1785 6.26525 10.0357 10.8525 6.13075 14.9876L0.140622 14.9876L0.14062 29.3245L6.137 29.3245L10.8324 31.0853C12.4509 31.6922 14.148 32 15.8765 32L26.408 32C28.2252 32 29.7036 30.5216 29.7036 28.7044C29.7036 27.9458 29.4458 27.2461 29.0134 26.6884C29.8642 26.0919 30.4215 25.1039 30.4215 23.9883C30.4215 23.2292 30.1629 22.5299 29.7301 21.9721C30.5814 21.3756 31.1395 20.3881 31.1395 19.2721ZM5.59712 27.4496L2.01562 27.4496L2.01562 16.8627L5.59712 16.8627L5.59712 27.4496ZM28.5619 15.9764L27.7209 15.9764L27.7209 17.8514L27.8439 17.8514C28.6273 17.8514 29.2645 18.4887 29.2645 19.2721C29.2645 20.0554 28.6273 20.6926 27.8439 20.6926L27.2563 20.6926L27.2563 20.6959C27.213 20.6943 27.1697 20.6926 27.126 20.6926L27.126 22.5676C27.9093 22.5676 28.5466 23.2049 28.5466 23.9882C28.5466 24.7715 27.9093 25.4088 27.1259 25.4088L26.408 25.4088L26.408 27.2838C27.1913 27.2838 27.8286 27.9211 27.8286 28.7044C27.8286 29.4878 27.1913 30.125 26.408 30.125L15.8765 30.125C14.3736 30.125 12.898 29.8574 11.4907 29.3297L7.47206 27.8227L7.47206 16.2977C8.13687 15.5923 9.99081 13.6183 11.8254 11.6044C13.1678 10.131 14.2387 8.92325 15.0088 8.01463C16.5109 6.24206 16.6679 5.87269 16.6679 5.45263L16.6679 1.90738C18.5963 2.15613 20.0909 3.80857 20.0909 5.80357L20.0909 7.282L18.3964 13.1353L28.5619 13.1353C29.3452 13.1353 29.9824 13.7725 29.9824 14.5559C29.9824 15.3393 29.3452 15.9764 28.5619 15.9764Z"
					fill="#5566E0"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10413_82611">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default LikeIcon;
